// Analysis 核心管理对象
import pointEvent from '@/utils/chinaPoint'

let production = false
let enabled = false
let token = ''
import { IS_CHINA } from '@/config' //区分国内海外埋点，如果是国内用火山埋点
import { analyticsAllowed } from '@/utils/cookieConsent'
class Analysis {
  constructor() {
    this.registry = []
  }

  register(platform) {
    // 注册平台
    this.registry.push(platform)
  }

  init() {
    this.registry.forEach((item) => {
      item.init()
    })
  }

  // 埋点
  logEvent(event, params) {
    console.info('%clogEvent:: ', 'color:red', event, params)
    this.registry.forEach((item) => {
      item.track(event, params)
    })
  }
  // identify
  identify(user) {
    this.registry.forEach((item) => item.identify(user))
  }

  registerCommonParams(data) {
    this.registry.forEach((item) => item.registerCommonParams(data))
  }
  //设置用户属性
  setUserProperties(data) {
    this.registry.forEach((item) => item.setUserProperties(data))
  }
  clear() {
    this.registry.forEach((item) => item.logout())
  }
}

// Mixpanel 实现
class MixpanelImpl {
  // 初始化
  init() {
    if (enabled) return
    if (process.env.NODE_ENV == 'production' && process.env.VUE_APP_MODE == 'prod') {
      production = true
      token = 'f5844b2fd8f78de67c91dda6784bce64'
    } else {
      token = 'd850e99320d38aaf758ca70926bca06d'
    }
    if (window.mixpanel) {
      if (!production) console.log('analytics.init')
      enabled = true
      window.mixpanel.init(token, { batch_requests: true })
    }
  }

  // 埋点
  track(event, params) {
    const properties = { ...params }
    if (!enabled) return
    // if (!production) console.log('analytics.track', event, properties)
    window.mixpanel.track(event, properties)
  }

  // 设置用户信息
  identify(userId) {
    window.mixpanel.identify(userId)
  }
  // 注册通用参数
  registerCommonParams(data) {
    window.mixpanel.register(data)
  }
  //设置用户属性
  setUserProperties(data) {
    window.mixpanel.people.set(data)
  }
  // 退出埋点
  logout() {
    console.log('mixpanel注销')
    window.mixpanel.reset && window.mixpanel.reset()
  }
}

class huoshanPoint {
  // 初始化
  init() {
    if (enabled) return
    if (process.env.NODE_ENV == 'production' && process.env.VUE_APP_MODE == 'prod') {
      production = true
      token = 20000988
    } else {
      token = 20000987
    }
    if (window.collectEvent) {
      if (!production) console.log('analytics.init')
      enabled = true
      window.collectEvent('init', {
        app_id: token, //  必须替换成申请的 app_id
        channel_domain: 'https://gator.volces.com', // 设置数据上送地址
        log: false, // 开启调试日志
        autotrack: false, // 开启全埋点采集，默认关闭，这里打开了全埋点，整个项目中所有点击事件都做了埋点
      })
      window.collectEvent('start')
    }
  }

  // 埋点
  track(event, params) {
    if (!enabled) return
    console.log('track', event)
    window.collectEvent(event, { ...params, log: true })
  }

  // 设置用户信息
  identify(userId) {
    console.log('identify', userId)
    window.collectEvent('config', { user_unique_id: userId })
  }
  // 注册通用参数
  registerCommonParams(data) {
    window.collectEvent('config', data)
  }
  //设置用户属性
  setUserProperties(data) {
    window.collectEvent('profileSet', data)
  }
  // 退出埋点
  logout() {
    window.collectEvent('config', {
      user_unique_id: null,
    })
  }
  clear() {
    this.logout()
  }
}
// TODO 其他埋点实现
const analytics = new Analysis()

export const analyticsInit = () => {
  // ⚠️ pointEvent 必须保持在 GDPR 闸门之前：国内构建它注入火山脚本；海外构建
  // 它把 mixpanel-browser 挂到 window.mixpanel（chinaPoint.js 的 else 分支）——
  // 这是 MixpanelImpl.init 里 if (window.mixpanel) 能成立的唯一来源，挪到闸门
  // 之后会让 Accept 后的初始化静默失败。只挂引用、不初始化不写存储，GDPR 无影响
  pointEvent(window, 'collectEvent')
  // 各类埋点客户端注册
  // 临时注释掉火山埋点，避免 invalid appid error
  // 国内环境不注册任何埋点，海外环境使用 Mixpanel
  if (!IS_CHINA) {
    /**
     * GDPR 闸门（opt-in）：海外只有用户在 Cookie Consent 里点过 Accept 才初始化
     * Mixpanel —— 未点/点了 Reject 都不注册，registry 为空时项目里散落的
     * logEvent/identify 全部安全空转，不会写任何 mp_* cookie。
     * 用户点 Accept 时 App.vue 会再调一次本函数，当场把 Mixpanel 拉起来。
     */
    if (!analyticsAllowed()) return
    analytics.register(new MixpanelImpl())
  }
  analytics.init()
}

export default analytics
